import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}


// 获取岗位下拉
const getStudyMapStation = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/GetStudyMapStation',
    'GET',
    TYPES.MAP_STATION,
    payload,
    false,
    apiRoot
  );
};


// 获取子系统下拉
const getStudyMapSystem = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/GetStudyMapSystem',
    'GET',
    TYPES.MAP_SYS,
    payload,
    false,
    apiRoot
  );
};

// 获取课程信息
const getStudyMapCourseList = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/GetStudyMapCourseList',
    'GET',
    TYPES.MAP_COURSE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取课程信息
const getStudyMapCourseStatus = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/GetStudyMapCourseStatus',
    'GET',
    TYPES.MAP_COURSE_STATUS,
    payload,
    false,
    apiRoot
  );
};


//获取用户默认配置
const getStudyMapUserSetting = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/GetStudyMapUserSetting',
    'GET',
    TYPES.MAP_USER_SETTING,
    payload,
    false,
    apiRoot
  );
};
// 保存用户默认配置
const saveStudyMapUserSetting = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/SaveStudyMapUserSetting',
    'POST',
    TYPES.SET_MAP_USER_SETTING,
    payload,
    false,
    apiRoot
  );
};
// 保存用户默认配置
const importStudyMap = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'StudyMap/Import',
    'POST',
    TYPES.SET_MAP_USER_SETTING,
    payload,
    false,
    apiRoot
  );
};
export const actions = {
  getStudyMapStation,
  getStudyMapSystem,
  getStudyMapCourseList,
  getStudyMapCourseStatus,
  getStudyMapUserSetting,
  saveStudyMapUserSetting
};

